/** Rutas relativas al prefijo `/logistica`. */
export const logisticsPaths = {
  orderNew: 'nueva',
  orderDetail: ':id',
  providers: 'proveedores',
  providerNew: 'proveedores/nueva',
  providerEdit: 'proveedores/:id',
} as const;
